import React from 'react';
import '../styles/Stepper.css';

export type Step = {
  label: string;
  icon?: React.ReactNode;
};

export type StepperProps = {
  steps: Step[];
  current: number; // 0-based index
  completedColor?: string;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
};

export default function Stepper({
  steps,
  current,
  completedColor = '#22c55e',
  activeColor = '#0057A4',
  inactiveColor = '#cbd5e1',
  className = '',
}: StepperProps) {
  const lastIndex = Math.max(steps.length - 1, 0);
  const clampedCurrent = Math.min(Math.max(current, 0), lastIndex);
  const progressPercent = lastIndex > 0 ? (clampedCurrent / lastIndex) * 100 : 0;

  return (
    <div className={`stepper ${className}`}>
      <div className="stepper__track">
        <div className="stepper__trackBase" />
        <div
          className="stepper__trackActive"
          style={{ width: `${progressPercent}%`, background: completedColor }}
        />
      </div>
      {steps.map((step, idx) => {
        const isCompleted = idx < clampedCurrent;
        const isActive = idx === clampedCurrent;
        return (
          <div
            className={`stepper__step${isCompleted ? ' stepper__step--completed' : ''}${isActive ? ' stepper__step--active' : ''}`}
            key={step.label}
          >
            <div
              className="stepper__circle"
              style={{
                background: isCompleted
                  ? completedColor
                  : isActive
                  ? activeColor
                  : inactiveColor,
                color: isCompleted || isActive ? '#fff' : '#64748b',
              }}
            >
              {isCompleted ? <i className="pi pi-check" /> : step.icon || idx + 1}
            </div>
            <div className="stepper__label">{step.label}</div>
          </div>
        );
      })}
    </div>
  );
}
